import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = { click: { 'scroll-to': 'scroll', } };
        this.fileName = this.$('fileName')[0];
    }
    init() {

        this.$('inputFile')[0].addEventListener( 'change', e => {
            let valueArray = e.target.value.split('\\');
            this.fileName.innerHTML = valueArray[valueArray.length - 1];

            let file = e.target.files[0];
            console.log(file);
            if(file){

                let classNames = this.fileName.dataset.showFileClass.split( ' ' );
                classNames.forEach( className => {
                    this.fileName.classList.add( className);
                });
            }
        });

    }
    destroy(){}
}
